export default {
  API_ERROR: 'Przykro nam, coś poszło nie tak. Spróbuj ponownie.',
  FORM_ERROR: 'Przepraszamy, ale musisz napisać coś więcej, żeby przekazać nam opinię.'
}
